<template>
<div>
  <normal-page :reportInfo="reportInfo" :currentPage="currentPage" v-if="reportInfo.language==='English'">
    <div v-for="(item,index) in imgEle" :key="index+'img'">
      <div style="text-align:center;">
        <img  :style="{width:item.imgWidth*5.97*0.05+'rem',outline:'1px solid #333'}" :src="$fileUrlFac(item.imgUrl, authData.sfileRight)" />
      </div>
      <div style="text-align:center;margin:0 auto;">
        <p
          style="border:none;width:100%;text-align:center;font-size:0.6rem;font-family:SimSun;over-flow:hidden;margin:-0.2rem 0 0.2rem 0;"
        >{{item.imgIndex?(imgEle.length>1?('图'+item.imgIndex+' '):('图'+' ')):item.imgIns}}{{item.imgIns}}</p>
      </div>
    </div>
  </normal-page>
  <normal-page :reportInfo="reportInfo" :currentPage="currentPage" v-else>
    <div v-for="(item,index) in imgEle" :key="index+'img'">
      <div style="text-align:center;">
        <img  :style="{width:item.imgWidth*5.97*0.05+'rem',outline:'1px solid #333'}" :src="$fileUrlFac(item.imgUrl, authData.sfileRight)" />
      </div>
      <div style="text-align:center;margin:0 auto;">
        <p
          style="border:none;width:100%;text-align:center;font-size:0.6rem;font-family:SimSun;over-flow:hidden;margin:-0.2rem 0 0.2rem 0;"
        >{{item.imgIndex?(imgEle.length>1?('Pic.'+item.imgIndex+' '):('Pic.'+' ')):item.imgIns}}{{item.imgIns}}</p>
      </div>
    </div>
  </normal-page>
</div>
  
</template>
<script>
import normalPage from "./NormalPage.vue";

export default {
  name: "imgPage",
  components: {
    normalPage
  },
  props: {
    reportInfo: {
      type: Object,
      default(){
        return {
          sampleName: "",
          contractNo: NaN,
          sampleAmount: "",
          report_display_no: "",
          project_display_no: "",
          testLocation: "",
          receiptDate: "",
          testDate: "",
          sampleInfo: "",
          standardList: [],
          langguage:undefined,
          totalPage: 1
      };
      }
    },
    currentPage: {
      type: Number,
      default: 0
    },
    imgEle: {
      type: Array,
      default: function() {
        return [];
      }
    },
    qrCodeUrl:{
      type:String,
      default:"nonValid"
    }
  },
  data() {
    return {
      authData:JSON.parse(localStorage.getItem("authData")),
      imgList: [
        {
          imgObj: null,
          imgUrl: "",
          imgIns: "图 1  "
        },
        {
          imgObj: null,
          imgUrl: "",
          imgIns: "图 1  "
        }
      ]
    };
  },
  methods: {},
  computed: {},
  created() {}
};
</script>
<style scoped>
</style>